import { render, staticRenderFns } from "./BikeRidesHistory.vue?vue&type=template&id=284a1ce0&scoped=true&lang=pug&"
import script from "./BikeRidesHistory.vue?vue&type=script&lang=js&"
export * from "./BikeRidesHistory.vue?vue&type=script&lang=js&"
import style0 from "./BikeRidesHistory.vue?vue&type=style&index=0&id=284a1ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a1ce0",
  null
  
)

export default component.exports